/* eslint-disable camelcase */
import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend, localize } from "vee-validate";
import { required, min, min_value, max_value, max, regex, email, confirmed } from "vee-validate/dist/rules";
import de from "vee-validate/dist/locale/de";
import fr from "vee-validate/dist/locale/fr";
import Translations from "@/translations/translations";

const locale = localStorage.getItem("language") || "en";

// Install De and Fr locales.
localize({
	fr,
	de
});

// add custom validation messages from thanslations files
localize({
	en: {fields: Translations.en.custom_validation},
	de: {fields: Translations.de.custom_validation},
	fr: {fields: Translations.fr.custom_validation}
});

// set locale
localize(locale);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

// Install required rule.
extend("required", required);
extend("regex", regex);
extend("min", min);
extend("min_value", min_value);
extend("max", max);
extend("max_value", max_value);
extend("confirmed", confirmed);
extend("email", email);

extend("minmax", {
	validate(value, { min, max }) {
		return value.length >= min && value.length <= max;
	},
	params: [ "min", "max" ]
});

extend("requiredObject", {
	validate(object) {
		for (const value of Object.values(object)) {
			if (value === null || value === undefined)
				return false;

		}
		return true;
	}
});
